import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ServicesHero = () => {
  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9c4f591e33b527f9fc4a0dcdb242979a.jpg"
          alt="Professional plumbing services"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Professional Plumbing<br />& Heating Services
          </h1>
          <p className="text-white text-xl md:text-2xl font-light mb-8">
            Comprehensive solutions for your home
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center space-x-2 bg-white text-[#1A2F4A] px-8 py-4 rounded-full hover:bg-gray-100 transition-all shadow-lg group whitespace-nowrap cursor-pointer"
          >
            <span className="font-semibold text-lg">Get a Free Quote</span>
            <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesHero;